export default {
  title: {
    'zh-cn': '角色管理',
    'zh-tw': '角色管理',
    'en': 'Role Management'
  },
  addRole: {
    'zh-cn': '新增角色',
    'zh-tw': '新增角色',
    'en': 'Add Role'
  },
  editRole: {
    'zh-cn': '编辑角色',
    'zh-tw': '編輯角色',
    'en': 'Edit Role'
  },
  deleteRole: {
    'zh-cn': '删除角色',
    'zh-tw': '刪除角色',
    'en': 'Delete Role'
  }
}

